/**
 * Services page API functions
 */

import qs from 'qs';

import { ServicesPageFallbackResponse } from '../fallback-data/services-page';
import { ServicesResponse } from '../types/services-page';
import { SERVICES_POPULATION } from '../utils/population';
import { STRAPI_URL } from './base';

/**
 * Fetch Services data with full population using qs
 */
export async function fetchServices(): Promise<ServicesResponse> {
  try {
    // Use the same clean object structure but with qs
    const queryString = qs.stringify(SERVICES_POPULATION, {
      encode: false,
    });

    // Construct the full URL
    const url = `${STRAPI_URL}/api/services?${queryString}`;

    const response = await fetch(url);

    if (!response.ok) {
      console.error('Error fetching services:', response.statusText);
      return ServicesPageFallbackResponse;
    }

    const data = await response.json();

    // Validate the response structure
    if (!data || !data.data) {
      console.error('Invalid response structure from API');
      return ServicesPageFallbackResponse;
    }

    return data;
  } catch (error) {
    console.error('Error fetching services:', error);
    return ServicesPageFallbackResponse;
  }
}
